import find from 'lodash/find'
import type { SelectOption } from '@ztechapps/webui.input'
import type { SpreadsheetCellSelectMode } from '@ztechapps/webui.data-tools'
import { Select } from '@ztechapps/webui.input'
import { SPREADSHEET_CELL_MENU_PROPS, SpreadsheetCellSelect } from '@ztechapps/webui.data-tools'
import { useMetadataContext } from './Context'

type MetadataValueSelectProps = {
  options?: SelectOption[]
  value?: string
  onChange?: (selected: SelectOption | null) => void
  spreadsheetMode?: SpreadsheetCellSelectMode
}

export const MetadataValueSelect = ({ options, value, onChange, spreadsheetMode }: MetadataValueSelectProps) => {
  const { hasRole } = useMetadataContext()
  // Resolved during render so the selected option is an element of `options` at mount — the
  // in-cell menu then highlights the current value instead of the first option.
  const selectedValue = find(options, (item) => item?.value === value) ?? null

  if (spreadsheetMode) {
    return (
      <SpreadsheetCellSelect
        options={options}
        value={selectedValue}
        onChange={onChange}
        disabled={!hasRole}
        {...SPREADSHEET_CELL_MENU_PROPS}
        onMenuStateChange={spreadsheetMode.onMenuStateChange}
        onCommit={spreadsheetMode.onCommit}
        defaultMenuIsOpen={spreadsheetMode.defaultMenuIsOpen}
        defaultInputValue={spreadsheetMode.defaultInputValue}
      />
    )
  }

  return <Select {...{ options, value: selectedValue, onChange }} disabled={!hasRole} />
}
